// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__28NsO","header":"ReportDetails_header__33Cnj","title":"ReportDetails_title__2PZo3","left":"ReportDetails_left__2pHc5"};